import type { ReactElement, ReactNode } from 'react';
import { auto as polyfillUnhandledRejection } from 'browser-unhandled-rejection';
import { cloneElement } from 'react';
import { getDatadogRumSessionId } from '../../utils/datadogRumUtils';
import { GeneralError } from '../pages/errors/GeneralError';
import { Component } from './Component';

polyfillUnhandledRejection();

interface IRouterProps {
    history?: any;
    location?: any;
    params?: any;
    routes?: any;
}

interface ICatchingComponentState {
    hasError: boolean;
    rumSessionId?: string;
}

interface ICatchingComponentProps extends IRouterProps {
    children: ReactNode;
}

export class CatchingComponent extends Component<ICatchingComponentProps, ICatchingComponentState> {
    constructor(props: ICatchingComponentProps, context?: unknown) {
        super(props, context);
        this.state = { hasError: false };
    }

    public componentDidMount() {
        window.addEventListener('unhandledrejection', this.handleUnhandledRejection.bind(this));
    }

    public componentWillUnmount() {
        window.removeEventListener(
            'unhandledrejection',
            this.handleUnhandledRejection as EventListenerOrEventListenerObject
        );
    }

    public UNSAFE_componentWillReceiveProps(nextProps: ICatchingComponentProps) {
        if (this.props.location !== nextProps.location) {
            this.setState({ hasError: false });
        }
    }

    public componentDidCatch() {
        const rumSessionId = getDatadogRumSessionId();
        this.setState({ hasError: true, rumSessionId });
    }

    public render() {
        if (this.state.hasError) {
            return <GeneralError rumSessionId={this.state.rumSessionId} />;
        } else if (this.props.children) {
            return cloneElement(this.props.children as ReactElement<any>, this.props);
        }

        return null;
    }

    private handleUnhandledRejection(promiseRejectionEvent: PromiseRejectionEvent) {
        promiseRejectionEvent.preventDefault();

        if (promiseRejectionEvent.reason) {
            if (
                promiseRejectionEvent.reason.name === 'AbortError' ||
                promiseRejectionEvent.reason.name === 'TimeoutError'
            ) {
                return;
            }
            console.error(promiseRejectionEvent.reason);
        }

        this.setState({ hasError: true });
    }
}
